/** All available column fields for the groups table */
export const GROUPS_TABLE_COLUMNS = ["name", "members", "projects", "createdDate", "options"];

/** The labels for the columns in the groups table */
export const GROUPS_TABLE_COLUMN_LABELS = {
  name: "Group name",
  members: "Members",
  projects: "Active projects",
  createdDate: "Created",
  options: "Options"
};

/** Sortable column fields for the groups table */
export const GROUPS_SORTABLE_FIELDS = ["name", "members", "projects", "createdDate"];